
import { BaseAPI } from "../../BaseAPI";
import * as environment from '../../../config/environment';

class KatalogTipiAPI extends BaseAPI {


    constructor() {
        const baseUrl = environment.API_URL + "Kutuphane/KatalogTipi";
        super(baseUrl);
    }


    KatalogTipi() {

        return this.get("");

    }

}
export default new KatalogTipiAPI();
